import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../../data/content';
export function Testimonials() {
  return <section className="py-24 relative" data-id="element-271" data-mp="3mgslk8tzzbay">
      <div className="container mx-auto px-4" data-id="element-272" data-mp="3mfr67s5y82nf">
        <div className="text-center mb-16" data-id="element-273" data-mp="3mezamhccq4x5">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-ink flex items-center justify-center gap-3" data-id="element-274" data-mp="3r8kc4jd5lh13">
            <span aria-hidden="true" data-id="element-275" data-mp="oaogz5e33z">❤️</span> MÁS PERSONAS QUE YA TIENEN EL SISTEMA
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-276" data-mp="40zw3vzc47gi">
          {testimonials.map((t, i) => <motion.figure key={t.initials} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="p-8 rounded-2xl bg-surface border border-line flex flex-col m-0" data-id="element-277" data-mp="e0z2bm8a7lq7" data-mpi={i}>
              <figcaption className="flex items-center gap-4 mb-6" data-id="element-278" data-mp="1slkoj78mmyfc">
                <div className="w-12 h-12 rounded-full bg-pistachio-200 text-pistachio-800 flex items-center justify-center font-bold text-lg" data-id="element-279" data-mp="1nu2oqmicb3vy">
                  {t.initials}
                </div>
                <div data-id="element-280" data-mp="1etec9w8lhbl6">
                  <div className="flex text-pistachio-500 mb-1" aria-label="5 de 5 estrellas" data-id="element-281" data-mp="1etxkgl8g0lm0">
                    {[...Array(5)].map((_, idx) => <StarIcon key={idx} size={14} fill="currentColor" aria-hidden="true" data-id="element-282" data-mp="26llrqtcd6hxz" data-mpi={idx} />)}
                  </div>
                  <div className="text-sm font-bold text-ink" data-id="element-283" data-mp="r3jztfs6tp1g">
                    {t.name}{' '}
                    <span className="text-muted font-normal ml-1" data-id="element-284" data-mp="m4gtls0h1crw">📍 {t.location}</span>
                  </div>
                  <div className="text-xs text-pistachio-700 mt-0.5" data-id="element-285" data-mp="nlw0z18qtsjf">{t.product}</div>
                </div>
              </figcaption>
              <blockquote className="text-muted leading-relaxed text-sm italic flex-grow" data-id="element-286" data-mp="sjeaasqoa9ry">
                "{t.quote}"
              </blockquote>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}